import React from 'react';
import { NavLink } from 'react-router-dom';
import { MdLogout } from "react-icons/md";

export default function Sidebar() {
  return (
    <aside className="yc-sidebar">
      <nav className="yc-nav">
        <NavLink to="/" end className={({ isActive }) => `yc-nav-item ${isActive ? 'active' : ''}`}>
          <svg className="yc-nav-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zm0 2c-3.866 0-7 3.134-7 7h2a5 5 0 0 1 10 0h2c0-3.866-3.134-7-7-7z" />
          </svg>
          Contacts
        </NavLink>
        <NavLink to="/inbox" className={({ isActive }) => `yc-nav-item ${isActive ? 'active' : ''}`}>
          <svg className="yc-nav-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M4 4h16a2 2 0 0 1 2 2v8h-6l-2 3h-4l-2-3H2V6a2 2 0 0 1 2-2zm16 10V6H4v8h4.764l2 3h2.472l2-3H20z" />
          </svg>
          Inbox
        </NavLink>
        <NavLink to="/broadcasts" className={({ isActive }) => `yc-nav-item ${isActive ? 'active' : ''}`}>
          <svg className="yc-nav-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M4 4h16v2H4V4zm0 7h16v2H4v-2zm0 7h10v2H4v-2z" />
          </svg>
          Broadcasts
        </NavLink>
        <NavLink to="/broadcast-history" className={({ isActive }) => `yc-nav-item ${isActive ? 'active' : ''}`}>
          <svg className="yc-nav-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7a6.98 6.98 0 0 1-4.95-2.05l-1.41 1.41A8.96 8.96 0 0 0 13 21a9 9 0 0 0 0-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" />
          </svg>
          Broadcast History
        </NavLink>
        <NavLink to="/groups" className={({ isActive }) => `yc-nav-item ${isActive ? 'active' : ''}`}>
          <svg className="yc-nav-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M4 4h16v2H4V4zm0 7h16v2H4v-2zm0 7h10v2H4v-2z" />
          </svg>
          Groups
        </NavLink>
        <NavLink to="/templates" className={({ isActive }) => `yc-nav-item ${isActive ? 'active' : ''}`}>
          <svg className="yc-nav-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M4 4h16v2H4V4zm0 7h16v2H4v-2zm0 7h10v2H4v-2z" />
          </svg>
          Templates
        </NavLink>
        <div style={{ paddingTop: '190px' }} />
        <button
          className="yc-nav-item yc-logout-button"
          onClick={() => {
            localStorage.removeItem("token");
            window.location.reload();
          }}
        >
          <MdLogout className="yc-nav-icon" />
          Logout
        </button>

      </nav>
    </aside>
  );
}


